document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector("form.shopify-product-form");

  if (productForm) registerProductForm(productForm);

  function registerProductForm(form) {
    const section = form.closest(".Section");
    const options = form.querySelectorAll(".Pills--input");
    const quantityInput = form.querySelector("input[name='quantity']");
    const price = form.querySelector(".Price");

    if (!quantityInput) return;

    let quantity = quantityInput.value || 1;

    quantityInput.addEventListener("change", function () {
      quantity = quantityInput.value;
      price.textContent = `$${((quantity * price.dataset.base) / 100).toFixed(
        2
      )}`;
    });

    options.forEach((option) => {
      option.addEventListener("change", onVariantChange);
    });

    function onVariantChange(e) {
      const target = e.target;
      const sectionId = section.dataset.sectionId;
      const newUrl =
        sectionId == "quick-view"
          ? target.dataset.oldProductUrl
          : target.dataset.productUrl;
      const newVariantId = target.dataset.variantId;

      let params = `section_id=${sectionId}&`;
      if (newVariantId) {
        // If the option value has a variant selection, call the section rendering api for that variant
        params += `variant=${newVariantId}`;
      } else {
        // If the option value selection has no variant, call the section rendering api with the selected option value IDs instead
        const selectedOptionValues = Array.from(
          form.querySelectorAll(".Pills--input:checked")
        )
          .map((element) => element.dataset.optionValueId)
          .join(",");
        params += `option_values=${selectedOptionValues}`;
      }

      console.log(`${newUrl}?${params}`);

      // Section Rendering API
      fetch(`${newUrl}?${params}`)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newForm = doc.querySelector("form.shopify-product-form");
          console.log(newForm);
          newForm.querySelector("input[name='quantity']").value = quantity;
          const newPrice = newForm.querySelector(".Price");
          newPrice.textContent = `$${(
            (quantity * newPrice.dataset.base) /
            100
          ).toFixed(2)}`;

          form.replaceWith(newForm);
          publish(PUB_SUB_EVENTS.contentAdded, { content: newForm });
        });
    }
  }

  subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
    const productForm = data.content.matches("form.shopify-product-form")
      ? data.content
      : data.content.querySelector("form.shopify-product-form");
    if (productForm) registerProductForm(productForm);
  });

  // Additional info section
  const addInfos = document.querySelectorAll(".Product_Additional_Item");

  addInfos.forEach((addInfo) => {
    const header = addInfo.querySelector(".Product_Additional_Item_Header");
    const collapsible = addInfo.querySelector(
      ".Product_Additional_Item_Content"
    );

    collapsible.style.setProperty("--height", `${collapsible.scrollHeight}px`);

    header.addEventListener("click", function () {
      addInfo.classList.toggle("Open");
    });
  });
});

/**
 * Media Carousel
 */

document.addEventListener("DOMContentLoaded", () => {
  let currentIndex = 0;

  const carousel = document.querySelector(".Product--media");

  if (!carousel) return;

  const mainMedia = carousel.querySelectorAll(".Product--image");

  const carouselInner = carousel.querySelector(".Product--media-inner");
  const leftBtn = carousel.querySelector(".Product--media-nav-left");
  const rightBtn = carousel.querySelector(".Product--media-nav-right");
  const thumbnails = carousel.querySelectorAll(".Product--media-thumbnail");

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", () => {
      currentIndex = index;
      updateCarousel();
    });
  });

  leftBtn.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  rightBtn.addEventListener("click", () => {
    if (currentIndex < mainMedia.length - 1) {
      currentIndex++;
      updateCarousel();
    }
  });

  window.addEventListener("resize", updateCarousel);

  function updateCarousel() {
    thumbnails.forEach((thumb) => thumb.classList.remove("Active"));
    thumbnails[currentIndex].classList.add("Active");

    carouselInner.scrollTo({
      left: mainMedia[currentIndex].offsetLeft,
      behavior: "smooth",
    });

    if (currentIndex === 0) {
      leftBtn.classList.add("Disabled");
    } else {
      leftBtn.classList.remove("Disabled");
    }

    if (currentIndex === mainMedia.length - 1) {
      rightBtn.classList.add("Disabled");
    } else {
      rightBtn.classList.remove("Disabled");
    }
  }

  updateCarousel();
});
